export const COMPONENTS_TYPES = {
  BANNER: 'banner',
  LOGIN: 'login',
  TEMPOPARY_USER_REGISTER: 'temporary_user_register',
  RESTORE_PASSWORD_LOGIN: 'restore-password-login',
  PAGE_404: 'page404',
  DEVICE_DETECTOR: 'device-detector',
  RESTORE_PASSWORD_CHECK_EMAIL: 'restore-password-check-email',
  RESTORE_PASSWORD_SET_NEW: 'restore-password-set-new',
  ORDERS_TYPES_FILTER: 'orders-types-filter',
  OFFERS_TYPES_FILTER: 'offers-types-filter',
  ORDERS_SIDEBAR_FILTER: 'orders-sidebar-filter',
  OFFERS_SIDEBAR_FILTER: 'offers-sidebar-filter',
  ORDERS_LIST: 'orders-list',
  ORDERS_LIST2: 'orders-list-2',
  ORDERS_CHOSEN_FILTERS: 'orders-chosen-filters',
  OFFERS_CHOSEN_FILTERS: 'offers-chosen-filters',
  DEALS_CHOSEN_FILTERS: 'deals-chosen-filters',
  ORDERS_DROPDOWN_FILTERS: 'orders-dropdown-filters',
  OFFERS_DROPDOWN_FILTERS: 'offers-dropdown-filters',
  ORDER_DETAILS: 'order-details',
  BACK_HEADER: 'back-header',
  CREATE_OFFER: 'create-offer',
  OFFERS_BY_ORDER: 'offers-by-order',
  OFFERS_BY_ORDERV2: 'offers-by-order-v2',
  HEADER_NAV_MENU: 'header-navigation',
  NAVIGATION_MENU: 'navigation-menu',
  LOGO: 'logo',
  HEADER_USER_MENU: 'header-user-menu',
  OFFERS_LIST: 'offers-list',
  DEALS_LIST: 'deals-list',
  DEALS_LIST2: 'deals-list2',
  DEALS_SIDEBAR_FILTER: 'deals_sidebar_filter',
  CANCEL_REQUEST_SIDEBAR_FILTER: 'cancel_request_sidebar_filter',
  DEALS_TYPES_FILTER: 'deals_types_filter',
  DEALS_DROPDOWN_FILTERS: 'deals_dropdown_filters',
  CANCEL_REQUESTS_LIST: 'cancel-requests-list',
  CANCEL_REQUESTS_FAST_DEALS_LIST: 'cancel-requests-fast-deals-list',
  CANCEL_REQUEST_DROPDOWN_FILTERS: 'cancel_request_dropdown_filters',
  DEAL_DETAILS: 'deal-details',
  OFFERS_BY_DEAL: 'offers-by-deal',
  DEAL_HEADER: 'deal-header',
  CONTACTS_LIST: 'contacts_list',
  CONTACTS_TOP_FILTER: 'contacts_top_filter',
  CONTACT_DETAILS: 'contact_details',
  CONTACT_DETAILS_HEADER: 'contact_details_header',
  DEALS_LIST_BY_FARMER: 'deals_list_by_farmer',
  HEADER_SEARCH: 'header-search',
  REDIRECT: 'redirect',
  PERSONAL_OFFICE_MENU: 'personal-office-menu',
  PAGE_HEADER: 'page-header',
  PERSONAL_INFO: 'personal-info',
  PERSONAL_INFO_CONTACTS_FO: 'personal-info-contacts',
  ADD_CONTACT_PERSON_FO: 'personal_info_add_contact_person',
  CHANGE_PASSWORD: 'change-password',
  USERS_LIST: 'users_list',
  ROLES_LIST: 'roles_list',
  BACK_OFFICE_HEADER: 'back_office_header',
  ADD_USER_BUTTON: 'add_user_button',
  ADD_USER: 'add_user',
  CHECK_CODE: 'check_code',
  CREATE_USER: 'create_user',
  USER_ACCESS: 'user_access',
  SHOW_FILTER_BUTTON: 'show_filter_button',
  PERMISSIONS_LIST: 'permissions-list',
  USERS_SIDEBAR_FILTER: 'users_sidebar_filter',
  PRODUCTS_LIST: 'dictionaries_list',
  DICTIONARY_LIST_BRAND: 'dictionary_list_brand',
  DICTIONARY_LIST_CATEGORY: 'dictionary_list_category',
  DICTIONARY_ITEM_GENERAL_INFO_CHEMICALS:
    'dictionary_item-general_info_chemicals',
  DICTIONARY_ITEM_GENERAL_INFO_SEEDS: 'dictionary_item-general_info_seeds',
  DICTIONARY_ITEM_TECHNICALS: 'dictionary_item_technicals',
  DICTIONARY_ITEM_TECHNICALS_SEEDS: 'dictionary_item_technicals_seeds',
  DICTIONARY_ITEM_USAGE: 'dictionary_item_usage',
  DICTIONARY_ITEM_USAGE_SEEDS: 'dictionary_item_seeds_usage',
  ADD_DICTIONARY_BUTTON: 'add_dictionary_button',
  ADD_PRODUCT_ITEM: 'add_dictionary_item',
  GET_DICTIONARY_LIST_ACTIVE_SUBSTANCE: 'dictionary_active_substance',
  GET_DICTIONARIES_CATEGORY_GROUP: 'category_group',
  GET_DICTIONARIES_PREPARATIVE_FORM: 'preparative_form',
  GET_DICTIONARIES_PRODUCT_GROUP: 'dictionary_product_group',
  DICTIONARIES_PRODUCT_SUB_GROUP: 'dictionary_product_sub_group',
  GET_DICTIONARIES_UNIT: 'dictionary_unit',
  GET_DICTIONARIES_QUANTITY_TYPE: 'dictionary_quantity_type',
  GET_DICTIONARY_LIST_APPLICATION_METHOD: 'application_method',
  GET_DICTIONARY_LIST_CHEMICAL_CLASS_GROUP: 'chemical-class-group',
  GET_DICTIONARY_LIST_SPECTRUM_ACTION_CHEMICAL: 'list_spectrum_action_chemical',
  GET_DICTIONARY_LIST_PRODUCT_PACKAGE: 'dictionary_product_package',
  GET_DICTIONARY_LIST_DISTRIBUTION_TYPE_CHEMICAL:
    'list_distribution_type_chemical',
  GET_DICTIONARY_LIST_TOXICITY_CLASS: 'list_toxicity_class',
  GET_DICTIONARY_LIST_APPLICATION_RATE_UNIT: 'list_application_rate_unit',
  GET_DICTIONARY_LIST_COLORS: 'dictionary_colors',
  GET_DICTIONARY_LIST_REPRODUCTION: 'dictionary_reproduction',
  GET_DICTIONARY_LIST_GROW_TYPE: 'dictionary_grow_type',
  GET_DICTIONARY_LIST_PLANT_TYPE: 'dictionary_plant_type',
  GET_DICTIONARY_LIST_PURPOSE: 'dictionary_purpose',
  GET_DICTIONARY_LIST_TECHNOLOGY_TYPE: 'dictionary_technology_type',
  GET_DICTIONARY_LIST_MATURITY_GROUP: 'dictionary_maturity_group',
  GET_DICTIONARY_LIST_GROW_SEASON: 'dictionary_grow_season',
  GET_DICTIONARY_LIST_POLLINATION_TYPE: 'dictionary_pollination_type',
  GET_DICTIONARY_LIST_FRUIT_AVERAGE_WEIGHT: 'dictionary_fruit_average_weight',
  GET_DICTIONARY_LIST_ADAPT_TYPE: 'dictionary_adapt_type',
  GET_DICTIONARY_LIST_ORIGIN_COUNTRY: 'dictionary_origin_country',
  GET_DICTIONARY_LIST_SPECIES: 'dictionary_species',
  GET_DICTIONARY_LIST_SEED_TYPE: 'dictionary_seed_type',
  GET_DICTIONARY_LIST_FRUIT_FORM: 'dictionary_fruit_form',
  GET_DICTIONARY_LIST_SORT_TYPE: 'dictionary_sort_type',
  ADD_CATEGORY_GROUP_FORM: 'add_category_group_form',
  ADD_PRODUCT_GROUP_FORM: 'add_product_group_form',
  ADD_PRODUCT_SUB_GROUP_FORM: 'add_product_sub_group_form',
  ADD_UNIT_FORM: 'add_unit_form',
  ADD_QUANTITY_TYPE: 'add_quantity_type',
  ADD_ACTIVE_SUBSTANCE: 'add_active_substance',
  ADD_BRAND: 'add_brand',
  ADD_PREPARATIVE_FORM: 'add_preparative_form',
  ADD_CATEGORY_FORM: 'add_category',
  ADD_DICTIONARY_APPLICATION_METHOD_FORM: 'add_dictionary_application_method',
  ADD_CHEMICAL_CLASS_GROUP_FORM: 'add_dictionary_chemical_class_group',
  ADD_SPECTRUM_ACTION_CHEMICAL: 'add_spectrum_action_chemical',
  ADD_DISTRIBUTION_TYPE_CHEMICAL: 'add_distribution_type_chemical',
  ADD_TOXICITY_CLASS: 'add_toxicity_class',
  ADD_APPLICATION_RATE_UNIT_FORM: 'add_application_rate_unit',
  ADD_SEEDS_FORM: 'add_seeds_form',
  ADD_COLOR_FORM: 'add_color',
  ADD_REPRODUCTION_FORM: 'add_reproduction',
  ADD_GROW_TYPE_FORM: 'add_grow_type',
  ADD_PLANT_TYPE_FORM: 'add_plant_type',
  ADD_PURPOSE_FORM: 'add_purpose',
  ADD_TECHNOLOGY_TYPE_FORM: 'add_technology_type',
  ADD_MATURITY_GROUP: 'add_maturity_group',
  ADD_GROW_SEASON: 'add_grow_season',
  ADD_POLLINATION_TYPE: 'add_pollination_type',
  ADD_FRUIT_AVERAGE_WEIGHT: 'add_fruit_average_weight',
  ADD_ADAPT_TYPE_FORM: 'add_adapt_type',
  ADD_ORIGIN_COUNTRY_FORM: 'add_origin_country',
  ADD_SPECIES_FORM: 'add_species',
  ADD_SEED_TYPE_FORM: 'add_seed_type',
  ADD_FRUIT_FORM: 'add_fruit_form',
  ADD_SORT_TYPE_FORM: 'add_sort_type',
  UPDATE_QUANTITY_TYPE_FORM: 'update_quantity_type_form',
  UPDATE_UNIT_FORM: 'update_unit_form',
  UPDATE_PRODUCT_GROUP_FORM: 'update_product_group_form',
  UPDATE_PRODUCT_SUB_GROUP_FORM: 'update_product_sub_group_form',
  UPDATE_PREPARATIVE_FORM_FORM: 'update_preparative_form_form',
  UPDATE_CATEGORY_GROUP_FORM: 'update_category_group_form',
  UPDATE_ACTIVE_SUBSTANCE_FORM: 'update_active_substance_form',
  UPDATE_CATEGORY_FORM: 'update_category_form',
  UPDATE_BRAND_FORM: 'update_brand_form',
  UPDATE_APPLICATION_METHOD_FORM: 'update_application_method_form',
  UPDATE_CHEMICAL_CLASS_GROUP_FORM: 'update_chenical_class_group_form',
  UPDATE_SPECTRUM_ACTION_CHEMICAL_FORM: 'update_spectrum_action_chemical_form',
  UPDATE_DISTRIBUTION_TYPE_CHEMICAL: 'update_distribution_type_chemical_form',
  UPDATE_TOXICITY_CLASS: 'update_toxicity_class_form',
  UPDATE_APPLICATION_RATE_UNIT: 'update_application_rate_unit_form',
  UPDATE_COLOR_FORM: 'update_color_form',
  UPDATE_REPRODUCTION_FORM: 'update_reproduction_form',
  UPDATE_GROW_TYPE_FORM: 'update_grow_type_form',
  UPDATE_PLANT_TYPE_FORM: 'update_plant_type_form',
  UPDATE_PURPOSE_FORM: 'update_purpose_form',
  UPDATE_TECHNOLOGY_TYPE_FORM: 'update_technology_type_form',
  UPDATE_MATURITY_GROUP_FORM: 'update_maturity_group_form',
  UPDATE_GROW_SEASON_FORM: 'update_grow_season_form',
  UPDATE_POLLINATION_TYPE_FORM: 'update_pollination_type_form',
  UPDATE_FRUIT_AVERAGE_WEIGHT_FORM: 'update_fruit_average_weight_form',
  UPDATE_ADAPT_TYPE_FORM: 'update_adapt_type_form',
  UPDATE_ORIGIN_COUNTRY_FORM: 'update_origin_country_form',
  UPDATE_SPECIES_FORM: 'update_species_form',
  UPDATE_SEED_TYPE_FORM: 'update_seed_type_form',
  UPDATE_FRUIT_FORM: 'update_fruit_form',
  UPDATE_SORT_TYPE_FORM: 'update_sort_type_form',
  DICTIONARY_SIDEBAR_FILTER: 'dictionary_sidebar_filter',
  SIDEBAR_FILTER: 'sidebar_filter',
  CATEGORY_FILTER: 'category_filter',
  PRODUCT_PACKAGE_FILTER: 'product_package_filter',
  LANGUAGE_SWITCHER: 'header-language-switcher',
  LINK_CHAT: 'header-link-chat',
  CONTACT_PERSONS: 'contact_persons',
  API_TOKENS: 'api_tokens',
  LOCATIONS: 'locations',
  BUSINESS_INFO: 'business_info',
  MERCHANDISERS_LIST: 'merchandisers',
  USER_DOCUMENTS: 'user_documents',
  USER_PRICE_LIST: 'user_price_list',
  ADD_CONTACT_PERSON_FORM: 'add_contact_person_form',
  ADD_MERCHANDISER: 'add_merchandiser',
  USER_SCROLL_MENU: 'user_scroll_menu',
  USER_LOCATIONS: 'personal-info-locations',
  USER_ADD_LOCATION: 'personal_info_add_location',
  USER_MERCHANDISERS_LIST: 'personal_info_merchandisers',
  USER_ADD_MERCHANDISER: 'personal_info_add_merchandiser',
  USER_DOCUMENTS_FO: 'personal_info_documents',
  USER_SUBSCRIPTIONS: 'personal_info_subscriptions',
  USERS_DROPDOWN_FILTER: 'users_dropdown_filter',
  PRICE_LIST: 'price-list',
  PRICING_TYPES_FILTER: 'pricing_types_filter',
  PRICING_CHOSEN_FILTERS: 'pricing_chosen_filters',
  PRICING_SIDEBAR_FILTER: 'pricing_sidebar_filter',
  PRICING_DROPDOWN_FILTERS: 'pricing_dropdown_filters',
  PRICING_SIDE_BUTTON: 'pricing_side_button',
  FAST_DEALS_LIST: 'fast_deals_list',
  FAST_DEALS_DROPDOWN_FILTERS: 'fast-deal-dropdown-filters',
  PRIVACY_POLICY: 'privacy-policy',
  USER_AGREEMENT: 'user-agreement',
  FARMER_PERMISSIONS: 'farmer_permissions',
  FAST_DEALS_SIDEBAR_FILTER: 'fast_deals_sidebar_filter',
  FAST_DEALS_CHOSEN_FILTERS: 'fast-deals-chosen-filters',
  FAST_DEALS_TYPES_FILTER: 'fast_deals_types_filter',
  CLIENTS_LIST: 'clients_list',
  GO_BACK_CLIENT_FORM_HEADER: 'go_back_header',
  ADD_CLIENT_FORM: 'add_client_form',
  UDPDATE_CLIENT_FORM: 'update_client_form',
  CLIENTS_FILTER: 'clients_filter',
  ADD_PRODUCT_ITEM_TECHNICALS: 'add_dictionary_item_technicals',
  ADD_PRODUCT_ITEM_USAGE: 'add_dictionary_item_usage',
  ADD_PRODUCT_ITEM_MEDIA_FILES: 'add_dictionary_item_media_files',
  ADD_PRODUCT_ITEM_DOCUMENTS: 'add_dictionary_item_documents',
  ADD_PRODUCT_ITEM_VIDEO: 'add_dictionary_item_video',
  UPDATE_DB_BUTTON: 'update_db_button',
  REFERRALS_LIST: 'referrals_list',
  REFERRALS_DEALS_LIST: 'referrals_deals_list',
  REFERRALS_FAST_DEALS_LIST: 'referrals_fast_deals_list'
};